import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

interface ThirdPartyRiderTrackUrlProps {
  onClick?: () => void;
  disabled?: boolean;
  thirdPartyCourier?: string | null;
}

const useStyles = makeStyles(
  () => ({
    buttonWidth: {
      margin: "3px",
      width: "100%"
    }
  }),
  { name: "TrackUrlButton" }
);

function ThirdPartyRiderTrackUrl(props: ThirdPartyRiderTrackUrlProps) {
  const { disabled, onClick, thirdPartyCourier } = props;
  const classes = useStyles(props);
  return (
    <Button
      id="trackThirdPartyRiderUrl"
      className={classes.buttonWidth}
      onClick={onClick}
      disabled={disabled}
      variant="contained"
      color="primary"
    >
      {thirdPartyCourier && `TRACK ${thirdPartyCourier}`}
    </Button>
  );
}

export default ThirdPartyRiderTrackUrl;
